import { useSubsStore } from '@/state/MsgTreeProvider'
import { selectRootFeedIds, type SubsStoreState, type SubRowVariant } from '@/msgdeskRuntime/state'
import { SubRow } from './SubRow'

// Root answers/submsges feed for the page panels.
// Source order matches the legacy projection contract (Stage F).

function currentProjectionMode(state: SubsStoreState) {
  return state.renderProjection.mode || 'msg'
}

function modeIsActive(activeMode: string, allowedModes?: string[]) {
  if (!allowedModes?.length) return true
  if (allowedModes.includes(activeMode)) return true
  return allowedModes.includes('msg') && ['answers', 'submsges', 'subs'].includes(activeMode)
}

export function RootSubsFeed({
  isSubmsges = false,
  variant = 'auto',
  mode = 'msg',
  activeModes,
}: {
  isSubmsges?: boolean
  variant?: SubRowVariant
  mode?: string
  activeModes?: string[]
}) {
  const { state } = useSubsStore()
  const storeState = state as SubsStoreState
  if (!modeIsActive(currentProjectionMode(storeState), activeModes)) return null
  const rootIds = selectRootFeedIds(storeState, isSubmsges, mode)
  return (
    <>
      {rootIds.map(id => (
        <SubRow key={id} elId={id} variant={variant} sourceMode={mode} />
      ))}
    </>
  )
}
